<template>
  <div class="stepper">
    <naj-button
      text
      class="step-item done"
    >
      <div class="step-icon">
        <v-icon color="white">
          mdi-check
        </v-icon>
      </div>
      <div class="step-name">
        {{ stepLocal.step1 }}
      </div>
    </naj-button>

    <naj-button
      text
      class="step-item icon"
      :class="{active: selectedStep === mainRequestStep.circuitOperation, done: selectedStep > mainRequestStep.circuitOperation}"
    >
      <div class="step-icon">
        <v-icon
          v-if="selectedStep > mainRequestStep.circuitOperation"
          color="white"
        >
          mdi-check
        </v-icon>
        <v-icon
          v-else
          color="white"
        >
          mdi-circle-outline
        </v-icon>
      </div>
      <div class="step-name">
        {{ stepLocal.step2 }}
      </div>
    </naj-button>

    <naj-button
      text
      class="step-item icon"
      :class="{active: selectedStep === mainRequestStep.openedProcedure, done: selectedStep === mainRequestStep.done,rejected :selectedStep === mainRequestStep.rejected}"
    >
      <div class="step-icon">
        <v-icon
          v-if="selectedStep === mainRequestStep.done"
          color="white"
        >
          mdi-check
        </v-icon>
        <v-icon
          v-else-if="selectedStep === mainRequestStep.rejected"
          color="red"
        >
          mdi-close-circle-outline
        </v-icon>
        <v-icon
          v-else-if="selectedStep === mainRequestStep.circuitOperation"
          color="white"
        >
          mdi-circle
        </v-icon>
        <v-icon
          v-else
          color="white"
        >
          mdi-circle-outline
        </v-icon>
      </div>
      <div class="step-name">
        {{ stepLocal.step3 }}
      </div>
    </naj-button>
  </div>
</template>

<script>

import { mainRequestStep } from '@/modules/bankruptcy/helpers/enum';

export default {
  name: 'RequestStepper',
  props: {
    currentStep: {
      type: [String, Number],
      required: false,
      default: null,
    },
  },
  data() {
    return {
      mainRequestStep,
      stepLocal: this.local.bankruptcy.bankruptcyFile.steps,
    };
  },
  computed: {
    steps() {
      return [
        {
          id: 1,
          title: this.local.bankruptcy.bankruptcyFile.steps.step1,
        },
        {
          id: 2,
          title: this.local.bankruptcy.bankruptcyFile.steps.step2,
        },
        {
          id: 3,
          title: this.local.bankruptcy.bankruptcyFile.steps.step3,
        },
      ];
    },
    selectedStep() {
      return this.currentStep * 1;
    },
  },
};
</script>

<style lang="scss" scoped>
    .stepper {
        display: flex;

        .step-item {
            margin-left: 15px;
            display: flex;

            .step-name {
                color: #dbdbdb;
                font-weight: 700;
                font-size: 14px;
            }

            .step-icon {
                width: 24px;
                height: 24px;
                border-radius: 100%;
                background-color: #dbdbdb;
                margin-left: 10px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #fff;
                font-weight: 700;
            }

            &.done {
                .step-name {
                    color: var(--app-primary-color);
                }

                .step-icon {
                    background-color: var(--app-primary-color);
                }
            }

            &.active {
                .step-name {
                    color: var(--app-dark-primary-color);
                }

                .step-icon {
                    background-color: var(--app-secondary-color);
                }
            }

            &.rejected {
                .step-name {
                    color: var(--app-dark-primary-color);
                }

                .step-icon {
                    background-color: #ffffff;
                }
            }
        }
    }
::v-deep .icon {
  .v-icon.v-icon {
    text-indent: initial;
  }
}
</style>
